import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export class HoverEvent {
  mouseEvent?: 'mouseover' | 'mouseleave';
  target?: any;
  menuRect?: any;
}

@Injectable()
export class SubmenuService {
  menuToggle = new BehaviorSubject<HoverEvent>({});
  subMenuPanelActive = new BehaviorSubject<boolean>(false);

  private _hasSubmenu = false;

  get hasSubmenu() {
    return this._hasSubmenu;
  }

  set hasSubmenu(value: boolean) {
    this._hasSubmenu = value;
  }

  subMenuActive(state: boolean) {
    this.subMenuPanelActive.next(state);
  }
}
